module.exports = __webpack_public_path__ + "static/sbn_logo_white-6f4462617753ebcf921be910c7043282.png";